
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from '../core/message-service/message.service';
import { SignUpDataTransferService } from '../services/signup-datatransfer.service';
import { UserInformationService } from '../services/userInformation.service';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-company-summary',
  templateUrl: './company-summary.component.html',
  styleUrls: ['./company-summary.component.css']
})
export class CompanySummaryComponent implements OnInit {
  companySummaryInformation: any;
  valid = false;
  loading: boolean;
  customerUserInformationId = 0;
  constructor( private signupDataTransferService: SignUpDataTransferService,
    private messageService: MessageService,
    private router: Router,
    private userInformationService: UserInformationService,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {
    this.commonService.checkLoggedInUser();
    this.loading = true;
    this.userInformationService.getUserInformationByEmail(sessionStorage.getItem("resEmail")).subscribe((res) => {
      this.companySummaryInformation = res;
      let companySummary = {
        'companyName': res.companyName,
        'fName': res.firstname,
        'lName': res.lastname,
        'email': res.email,
        'cell': res.phone,
        'officePhone': res.officePhone
      }
      sessionStorage.setItem("companySummary", JSON.stringify(companySummary));
      if (this.companySummaryInformation.companyName != "") {
        this.valid = true;
        this.loading = false;
        sessionStorage.setItem("userName", res.email);
        sessionStorage.setItem("password", res.password);
        this.signupDataTransferService.setCompanySummaryInformation(res);
      }
    }, (err) => {
      console.log(err);
    });
  }

  goToSummarySecond() {
    if (!this.valid) {
      this.messageService.showWarning("Errror creating company profile");
      return;
    }
    this.router.navigateByUrl('/companySummary2');
  }

}
